import VehiclePane from "./VehiclePane";

export default VehiclePane;
export { VehiclePane };
